import { ActionReducerMapBuilder, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { ITasksState } from '.';
import { api } from '../../api/api';
import { JoinChannelTasksDto } from '../../pages/TaskPage/Tasks/JoinChannelTask/JoinChannelTaskPage';
import { VkShareTaskDto } from '../../pages/TaskPage/Tasks/VkShareTask/VkShareTask';
import { ITicketsBalances } from '../../model/user-info.interface';

export class QuizTaskDto {
    allowDate!: number;
}

export class HomescreenShortcutTaskDto {
    isPerformed!: boolean;
    reward!: Partial<ITicketsBalances>;
}

export interface IGetTasksResponse {
    joinChannelTasks: JoinChannelTasksDto,
    vkShareTasks: VkShareTaskDto[],
    quizTask: QuizTaskDto,
    homescreenShortcutTask: HomescreenShortcutTaskDto,

    referalsCount: number;
    referalReward: number;
    interestsCount: number;
};

export const getTasks = createAsyncThunk<IGetTasksResponse>(
    'getTasks',
    async () => await api.tasks.getTasks()
);

const getTasksHandler = (builder: ActionReducerMapBuilder<ITasksState>) => {
    builder
        .addCase(getTasks.pending, (state: ITasksState) => {
            state.loading = true;
            state.error = "";
        })
        .addCase(getTasks.fulfilled, (state: ITasksState, action: PayloadAction<IGetTasksResponse>) => {
            if (!action.payload)
                return;

            state.loading = false;
            state.joinChannelTasks = action.payload.joinChannelTasks;

            state.joinChannelTasks.activeTasks = state.joinChannelTasks.activeTasks
                .sort((a, b) => (a.subscribed ? 1 : -1) * 1000 - (b.subscribed ? 1 : -1) * 1000 + a.taskId - b.taskId) ?? [];

            state.joinChannelTasks.archiveTasks = state.joinChannelTasks.archiveTasks
                .sort((a, b) => (a.subscribed ? 1 : -1) * 1000 - (b.subscribed ? 1 : -1) * 1000 + a.taskId - b.taskId) ?? [];

            state.vkShareTasks = action.payload.vkShareTasks ?? [];
            state.quizTask = action.payload.quizTask;
            state.homescreenShortcutTask = action.payload.homescreenShortcutTask;

            state.referalsCount = action.payload.referalsCount;
            state.referalReward = action.payload.referalReward;
            state.interestsCount = action.payload.interestsCount;
        })
        .addCase(getTasks.rejected, (state: ITasksState) => {
            state.loading = false;
            state.error = 'Unable to get tasks';
        });
};

export default getTasksHandler;